import React, { useState } from 'react';
import { Logo } from './Logo';
import { MenuIcon, XIcon } from 'lucide-react';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-87" data-mp="2ilquen6cd97t">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-88" data-mp="2ink3sa8ca7ji">
        <div className="flex justify-between items-center py-4" data-id="element-89" data-mp="2nllk4nedrsra">
          <div className="flex-shrink-0" data-id="element-90" data-mp="2rmf97k3k7dlr">
            <div className="h-12 w-auto" data-id="element-91" data-mp="2rldyxhudav53">
              <Logo isSmall={true} data-id="element-92" data-mp="2wl8p1j6bjgp3" />
            </div>
          </div>
          {/* Desktop navigation */}
          <nav className="hidden md:flex space-x-10" data-id="element-93" data-mp="31byroond15g3">
            <a href="#about" className="text-slate-700 hover:text-[#D4AF37] transition-colors font-medium" data-id="element-94" data-mp="31ch00jnara4d">
              About
            </a>
            <a href="#services" className="text-slate-700 hover:text-[#D4AF37] transition-colors font-medium" data-id="element-95" data-mp="3bb69pp51ho9j">
              Services
            </a>
            <a href="#performance" className="text-slate-700 hover:text-[#D4AF37] transition-colors font-medium" data-id="element-96" data-mp="2wlvzt53f6hr6">
              Performance
            </a>
            <a href="#team" className="text-slate-700 hover:text-[#D4AF37] transition-colors font-medium" data-id="element-97" data-mp="2mlvghj5jw1mz">
              Team
            </a>
            <a href="#contact" className="text-slate-700 hover:text-[#D4AF37] transition-colors font-medium" data-id="element-98" data-mp="3fbvldi01xepu">
              Contact
            </a>
          </nav>
          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-99" data-mp="35jy9e917yiq2">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-slate-700 hover:text-[#D4AF37] focus:outline-none" data-id="element-100" data-mp="30mfve48chdb7">
              {isMenuOpen ? <XIcon size={24} data-id="element-101" data-mp="3ta28c33gpuaq" /> : <MenuIcon size={24} data-id="element-102" data-mp="3t9sjwjy2fv75" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden" data-id="element-103" data-mp="1wcee40n26svg">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white shadow-lg" data-id="element-104" data-mp="1wbcv99zsx236">
            <a href="#about" className="block px-3 py-2 text-base font-medium text-slate-700 hover:text-[#D4AF37]" data-id="element-105" data-mp="1hojkmi188khb">
              About
            </a>
            <a href="#services" className="block px-3 py-2 text-base font-medium text-slate-700 hover:text-[#D4AF37]" data-id="element-106" data-mp="18mtwbl2n61nr">
              Services
            </a>
            <a href="#performance" className="block px-3 py-2 text-base font-medium text-slate-700 hover:text-[#D4AF37]" data-id="element-107" data-mp="ypp8zhx2805d">
              Performance
            </a>
            <a href="#team" className="block px-3 py-2 text-base font-medium text-slate-700 hover:text-[#D4AF37]" data-id="element-108" data-mp="2t2nd1js620k9">
              Team
            </a>
            <a href="#contact" className="block px-3 py-2 text-base font-medium text-slate-700 hover:text-[#D4AF37]" data-id="element-109" data-mp="mdv7crlapwew">
              Contact
            </a>
          </div>
        </div>}
    </header>;
};